import { useWatch } from 'react-hook-form';
import { FIELDS_MATCH_TOGGLE_IDS } from '../YesNoSplitEditor.constants';

export const useIsMatchTriggeringEventSelected = () => {
  const matchTriggeringEventFields = useWatch({ name: 'matchTriggeringEventFields' });

  const isMatchTriggeringEventSelected =
    matchTriggeringEventFields === FIELDS_MATCH_TOGGLE_IDS.TRIGGERING_EVENT;

  return isMatchTriggeringEventSelected;
};
